import React, { useEffect, useMemo, useState } from 'react';
import { IDNameDescriptionDictionary } from '../../models/Site';
import moment from 'moment';
import { IDNameDescriptionItemSelect } from '../../components/_IDNameDescriptionItemSelect';
import { SimulatorModel } from '../../models/SimulatorModel';
import { get, set } from 'lodash';
import { CustomerCardModel } from '../../models/CustomerCardModel';
import "../ClientsStyle.css"
import CompDatePicker from '../../components/compDatePicker/_CompDatePicker';
import { CustomerModel, Gender, IDNameDescriptionItem, Vehicle } from '../../models/superbit-api-models';
import { Select } from 'antd';
import { id, ro, tr } from 'date-fns/locale';
import MessegePopupClient from '../_MessegePopupClient';
import PolicyInput from '../../components/_PolicyInput';
import { SubscribersModel } from '../../models/SubscribersModel';
import { PolicyModel } from '../../models/PolicyModel';
import CheckBox from '../../components/_CheckBox';
const { Option } = Select;

export interface ClientPolicyDetailsCarOrRiderProps {
    policyItem: any; // Replace 'any' with the actual type of policy if available
    authorizedToDrive: IDNameDescriptionDictionary;
    eventTypes: IDNameDescriptionDictionary;
    passedTypeOfInsurance: IDNameDescriptionDictionary;
    collectionMethodtype: IDNameDescriptionDictionary;
    collectionRouteType: IDNameDescriptionDictionary;
    policyTypes: IDNameDescriptionDictionary;
    customerData: any;
}

const ClientPolicyDetailsCarOrRider: React.FC<ClientPolicyDetailsCarOrRiderProps> = ({
    policyItem,
    authorizedToDrive,
    eventTypes,
    passedTypeOfInsurance,
    collectionMethodtype,
    collectionRouteType,
    policyTypes,
    customerData
}) => {
    const customerModel: CustomerCardModel = new CustomerCardModel();
    const simulatorModel: SimulatorModel = new SimulatorModel();

    const [policy, setPolicy] = useState<any>(policyItem);
    const [oldPolicy, setOldPolicy] = useState<any>(policyItem);
    const [edit, setEdit] = useState(false);

    const [branchesList, setBranchesList] = useState<any[]>([]);
    const [routesList, setRoutesList] = useState<any[]>([]);

    const [ageYoungDriver, setAgeYoungDriver] = useState<number>(0);
    const [ageMainDriver, setAgeMainDriver] = useState<number>(0);


    const [driverYoungSeniorityDate, setDriverYoungSeniorityDate] = useState<Date>();
    const [driverMainSeniorityDate, setDriverMainSeniorityDate] = useState<Date>();

    const [driverYoungSeniority, setDriverYoungSeniority] = useState<number>(0);
    const [driverMainSeniority, setDriverMainSeniority] = useState<number>(0);

    const [genders, setGenders] = useState<any[]>([]);
    const [showPopUp, setShowPopUp] = useState<boolean>(false);

    const [insuranceCompanies, setInsuranceCompanies] = useState<IDNameDescriptionDictionary>({});
    const [licenseNumberLoading, setLicenseNumberLoading] = useState<boolean>(false);

    const [vehicleOwnership, setVehicleOwnership] = useState<IDNameDescriptionDictionary>({});

    const policyData = useMemo(() => {

        simulatorModel.getGenderTypes().then((res: any) => {
            const gendersList: any = [];
            Object.keys(res).forEach((key: string) => {
                const gender = res[key];
                gendersList.push({
                    label: gender.description,
                    value: gender.id.toString()
                })
            })
            setGenders(gendersList);
        })

        const policy_data: Record<string, any> = {};

        if (policy && (policy.itemType === 'policy' || policy.itemType == undefined)) {
            policy_data['fullName'] = customerData.fullName ? customerData.fullName : '';
            policy_data['eventType'] = policy.policyAdditionDetails && policy.policyAdditionDetails.eventType ? policy.policyAdditionDetails.eventType : '';
            policy_data['policyNumber'] = policy.policyNumber ? policy.policyNumber : '';
            policy_data['brunchName'] = policy.policyAdditionDetails && policy.policyAdditionDetails.vehiclePolicyType == 6 ? "פוליסת חובה" :
                policy.policyAdditionDetails.route && policy.policyAdditionDetails.route.comment ? policy.policyAdditionDetails.route.comment : '';
            // policy_data['branchName'] = 'רכב';
            // policy_data['agentNumber'] = '23001';
            policy_data['licenseNumber'] = policy.policyAdditionDetails && policy.policyAdditionDetails.vehicle &&
                policy.policyAdditionDetails.vehicle.licenseNumber ? policy.policyAdditionDetails.vehicle.licenseNumber : '';
            policy_data['carYear'] = policy.policyAdditionDetails && policy.policyAdditionDetails.vehicle &&
                policy.policyAdditionDetails.vehicle.carYear ? policy.policyAdditionDetails.vehicle.carYear : '';
            policy_data['vehicleType'] = 'פרטי';
            policy_data['weightVolume'] = policy.policyAdditionDetails && policy.policyAdditionDetails.vehicle &&
                policy.policyAdditionDetails.vehicle.weightVolume ? policy.policyAdditionDetails.vehicle.weightVolume : '';
            policy_data['modelCode'] = policy.policyAdditionDetails && policy.policyAdditionDetails.vehicle &&
                policy.policyAdditionDetails.vehicle.modelCode ? policy.policyAdditionDetails.vehicle.modelCode : '';
            policy_data['vehicleSubModel'] = policy.policyAdditionDetails && policy.policyAdditionDetails.vehicle &&
                policy.policyAdditionDetails.vehicle.vehicleSubModel && policy.policyAdditionDetails.vehicle.vehicleSubModel.name ? policy.policyAdditionDetails.vehicle.vehicleSubModel.name : '';
            policy_data['vehicleId'] = policy.policyAdditionDetails && policy.policyAdditionDetails.vehicle && policy.policyAdditionDetails.vehicle.id ? policy.policyAdditionDetails.vehicle.id : '';
            policy_data['gearsType'] = policy.policyAdditionDetails && policy.policyAdditionDetails.vehicle && policy.policyAdditionDetails.vehicle.gearsType >= 0 ? policy.policyAdditionDetails.vehicle.gearsType == 1 ? 'אוטומט' : 'ידני' : '';
            policy_data['vehicleOwnership'] = policy.policyAdditionDetails && policy.policyAdditionDetails.vehicle && policy.policyAdditionDetails.vehicle.vehicleOwnership >= 0
                ? policy.policyAdditionDetails.vehicle.vehicleOwnership : '';
            policy_data['premia'] = policy.policyAdditionDetails && policy.policyAdditionDetails.premiumSum;
            policy_data['updatedDate'] = moment(customerData.updatedDate).format('DD/MM/YYYY');
            policy_data['authorizedToDrive'] = policy.policyAdditionDetails && policy.policyAdditionDetails.driversType >= 0 ? Number(policy.policyAdditionDetails.driversType) : "";
            policy_data['numberOfPayments'] = policy.policyAdditionDetails && policy.policyAdditionDetails.numberOfPayments ? policy.policyAdditionDetails.numberOfPayments : "";
            policy_data['agentNumber'] = policy.policyAdditionDetails && policy.policyAdditionDetails.agentNumber ? policy.policyAdditionDetails.agentNumber : "";
            policy_data['eventDate'] = policy.policyAdditionDetails && policy.policyAdditionDetails.eventDate ? moment(policy.policyAdditionDetails.eventDate).format('DD/MM/YYYY') : "";
            policy_data['policyType'] = policy.policyType && (policy.policyType.policyTypeId == '1' || policy.policyType.policyTypeId == '12') ? 1 : 2; // 1 - policy,rider  . 2 - other
            
        }
        policy_data['paymentDetails'] = policy.policyAdditionDetails && policy.policyAdditionDetails.paymentDetails ? policy.policyAdditionDetails.paymentDetails : ["", "", "", "", "", ""];
        // console.log('policy_data', policy.itemType, policy_data, policy);

        return policy_data;
    }, [policy]);

    const init = async () => {
        setVehicleOwnership(await simulatorModel.getVehicleOwnership());
    }

    useEffect(() => {
        init();

        setDriverYoungSeniorityDate(policy.policyAdditionDetails && policy.policyAdditionDetails.driverYoungSeniorityDate ?
            new Date(policy.policyAdditionDetails.driverYoungSeniorityDate) : undefined);

        setDriverMainSeniorityDate(policy.policyAdditionDetails && policy.policyAdditionDetails.driverMainSeniorityDate ?
            new Date(policy.policyAdditionDetails.driverMainSeniorityDate) : undefined);

        if (policy.policyAdditionDetails && policy.policyAdditionDetails.driverYoungBirthDate) {
            setAgeYoungDriver(policy.policyAdditionDetails.driverYoungAge);
        }
        // if (policy.policyAdditionDetails && policy.policyAdditionDetails.driverMainBirthDate) {
        //     setMainDriverAge(policy.policyAdditionDetails.driverMainAge);
        // }

         if (policy.policyAdditionDetails && policy.policyAdditionDetails.driverMainBirthDate) {
            setAgeMainDriver(policy.policyAdditionDetails.driverMainAge);
        }

        if (policy.policyAdditionDetails && policy.policyAdditionDetails.driverYoungSeniorityDate) {
            setDriverYoungSeniority(policy.policyAdditionDetails.driverYoungSeniority);
        }
        if (policy.policyAdditionDetails && policy.policyAdditionDetails.driverMainSeniorityDate) {
            setDriverMainSeniority(policy.policyAdditionDetails.driverMainSeniority);
        }
        getInsuranceCompanies();
        createDateListOfBranches(policy.policyType.policyTypeId, Number(policy.policyAdditionDetails.vehiclePolicyType));


    }, [])

    const getCCNumber = () => {

        return policy && policy.policyAdditionDetails.paymentDetails
            ? policy.policyAdditionDetails.paymentDetails[0]
            : "";
    };


    const setCCNumber = (value: string) => {
        var paymentDetails = policy.policyAdditionDetails && policy.policyAdditionDetails.paymentDetails ? policy.policyAdditionDetails.paymentDetails : ["", "", "", "", "", ""];
        paymentDetails[0] = value;


        setPolicy((prevPolicy: any) => ({
            ...prevPolicy,
            policyAdditionDetails: {
                ...prevPolicy.policyAdditionDetails,
                paymentDetails: paymentDetails
            }
        }));


    };


    const getValidityDate = () => {
        return policy && policy.policyAdditionDetails.paymentDetails
            ? policy.policyAdditionDetails.paymentDetails[1]
            : "";
    };

    const setValidityDate = async (value: string) => {

        var paymentDetails = policy.policyAdditionDetails && policy.policyAdditionDetails.paymentDetails ? policy.policyAdditionDetails.paymentDetails : ["", "", "", "", "", ""];
        paymentDetails[1] = value;
        setPolicy((prevPolicy: any) => ({
            ...prevPolicy,
            policyAdditionDetails: {
                ...prevPolicy.policyAdditionDetails,
                paymentDetails: paymentDetails
            }
        }));
    };

    const getCVV = () => {
        return policy && policy.policyAdditionDetails.paymentDetails
            ? policy.policyAdditionDetails.paymentDetails[2]
            : "";
    };

    const setCVV = async (value: string) => {

        var paymentDetails = policy.policyAdditionDetails && policy.policyAdditionDetails.paymentDetails ? policy.policyAdditionDetails.paymentDetails : ["", "", "", "", "", ""];
        paymentDetails[2] = value;
        setPolicy((prevPolicy: any) => ({
            ...prevPolicy,
            policyAdditionDetails: {
                ...prevPolicy.policyAdditionDetails,
                paymentDetails: paymentDetails
            }
        }));
    };

    const getIdentity = () => {
        return policy && policy.policyAdditionDetails.paymentDetails
            ? policy.policyAdditionDetails.paymentDetails[3]
            : "";
    };

    const setIdentity = async (value: string) => {

        var paymentDetails = policy.policyAdditionDetails && policy.policyAdditionDetails.paymentDetails ? policy.policyAdditionDetails.paymentDetails : ["", "", "", "", "", ""];
        paymentDetails[3] = value;
        setPolicy((prevPolicy: any) => ({
            ...prevPolicy,
            policyAdditionDetails: {
                ...prevPolicy.policyAdditionDetails,
                paymentDetails: paymentDetails
            }
        }));
    };

    const getPayerName = () => {
        return policy && policy.policyAdditionDetails.paymentDetails
            ? policy.policyAdditionDetails.paymentDetails[4]
            : "";
    };

    const setPayerName = async (value: string) => {

        var paymentDetails = policy.policyAdditionDetails && policy.policyAdditionDetails.paymentDetails ? policy.policyAdditionDetails.paymentDetails : ["", "", "", "", "", ""];
        paymentDetails[4] = value;
        setPolicy((prevPolicy: any) => ({
            ...prevPolicy,
            policyAdditionDetails: {
                ...prevPolicy.policyAdditionDetails,
                paymentDetails: paymentDetails
            }
        }));
    }

    const getPayerPhoneNumber = () => {
        return policy && policy.policyAdditionDetails.paymentDetails
            ? policy.policyAdditionDetails.paymentDetails[5]
            : "";
    };

    const setPayerPhoneNumber = async (value: string) => {

        var paymentDetails = policy.policyAdditionDetails && policy.policyAdditionDetails.paymentDetails ? policy.policyAdditionDetails.paymentDetails : ["", "", "", "", "", ""];
        paymentDetails[5] = value;
        setPolicy((prevPolicy: any) => ({
            ...prevPolicy,
            policyAdditionDetails: {
                ...prevPolicy.policyAdditionDetails,
                paymentDetails: paymentDetails
            }
        }));
    }

    const createDateListOfBranches = async (policyType: number, type: number) => {
        setRoutesList([]);

        let branches: any[] = [];
        try {
            branches = await new PolicyModel().policyGetRoutesByConditions({
                insuranceCompanyId: policy.insuranceCompanyId,
                policyTypeId: 1,
                vehiclePolicyType: Number(type)
            });
        } catch (error) {
            console.error('createDateListOfBranches-error', error);
        }
        setBranchesList(branches);
        console.log('createDateListOfBranches-branches', branches);

        let arrayBranches: any[] = [];
        arrayBranches.push({ value: 0, name: "בחר ענף", isCompulsoryRouteId: false });
        branches.forEach((branch: any) => {
            let newData = {
                value: branch.routeId, name: branch.comment,
                isCompulsoryRouteId: branch.compulsoryRouteId ? true : false
            };
            arrayBranches.push(newData);
        });
        setRoutesList(arrayBranches);
    }

    const getInsuranceCompanies = () => {


        const insuranceCompaniesData = localStorage.getItem('insuranceCompanies');
        if (!insuranceCompaniesData) {
            return {};
        }

        const companies = JSON.parse(insuranceCompaniesData);
        if (!companies || !Array.isArray(companies) || companies.length === 0) {
            return {};
        }

        let dictionary = new IDNameDescriptionDictionary();
        const _key = "0";
        dictionary[_key] = new IDNameDescriptionItem();
        dictionary[_key].id = 0;
        dictionary[_key].name = "בחר חברה";
        dictionary[_key].description = "בחר חברה";
        companies.forEach((company: any, index: number) => {
            let newData = new IDNameDescriptionItem({ id: company.value, name: company.label, description: company.label });
            dictionary[index] = newData;
        });
        setInsuranceCompanies(dictionary);
    }

    const getAge = (date: Date): number => {
        if (!date) return 0;
        const dateOfBirth = new Date(date);
        const today = new Date();
        let age = today.getFullYear() - dateOfBirth.getFullYear();
        const m = today.getMonth() - dateOfBirth.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < dateOfBirth.getDate())) {
            age--;
        }
        return age;
    }

    const onChangeAuthorizedToDrive = (field: string, value: any) => {
        // Handle authorized to drive change logic here
        console.log(`Authorized to drive changed to ${value}`);
        setPolicy((prevPolicy: any) => ({
            ...prevPolicy,
            policyAdditionDetails: {
                ...prevPolicy.policyAdditionDetails,
                driversType: Number(value)
            }
        }));
    };


    const onAdditionalDetailsChange = (field: string, value: any) => {
        // Handle additional details change logic here
        console.log(`Additional details field ${field} changed to ${value}`, typeof value);
        setPolicy((prevPolicy: any) => ({
            ...prevPolicy,
            policyAdditionDetails: {
                ...prevPolicy.policyAdditionDetails,
                [field]: value
            }
        }));
    };

    const onAdditionalDetailsChangeRoute = (value: any) => {
        console.log(`onAdditionalDetailsChangeRoute details route changed to ${value}`, typeof value);
        const selectedRoute = branchesList.find((route: any) => route.routeId === value || route.compulsoryRouteId === value);
        console.log('onAdditionalDetailsChangeRoute-selectedRoute', selectedRoute);
        if (selectedRoute) {
            setPolicy((prevPolicy: any) => ({
                ...prevPolicy,
                policyAdditionDetails: {
                    ...prevPolicy.policyAdditionDetails,
                    route: {
                        routeId: selectedRoute.routeId,
                        compulsoryRouteId: selectedRoute.compulsoryRouteId,
                        comment: selectedRoute.comment,
                        id: selectedRoute.id,
                        agentId: selectedRoute.agentId,
                        containsRider: selectedRoute.containsRider,
                        specificDetails: selectedRoute.specificDetails,
                        status: selectedRoute.status,
                        temsAndCovers: selectedRoute.temsAndCovers,
                        temsAndCoversFile: selectedRoute.temsAndCoversFile,
                        temsAndCoversFilePath: selectedRoute.temsAndCoversFilePath
                    },
                    routeId: selectedRoute.id
                }
            }))
        }
    }

    const onChangeCheckBox = (field: string, value: any) => {
        // Handle checkbox change logic here
        console.log(`Checkbox field ${field} changed to ${value}`, typeof value);
        setPolicy((prevPolicy: any) => ({
            ...prevPolicy,
            policyAdditionDetails: {
                ...prevPolicy.policyAdditionDetails,
                [field]: value
            }
        }));
    };

    const onAdditionalDetailsChangeInsuranceType = async (field: string, value: any) => {
        // Handle additional details change logic here
        console.log(`Additional details field ${field} changed to ${value}`, typeof value);
        setPolicy((prevPolicy: any) => ({
            ...prevPolicy,
            policyAdditionDetails: {
                ...prevPolicy.policyAdditionDetails,
                vehiclePolicyType: Number(value)
            }
        }));

        if (policy.insuranceCompanyId && policy.insuranceCompanyId.length > 0 && value) {
            // use api to get list of branches by insurance company id and policy type
            createDateListOfBranches(policy.policyType.policyTypeId, Number(value));
        }
    };

    const onInsuranceCompanyChange = (field: string, value: any) => {
        // Handle insurance company change logic here
        console.log(`Insurance company field ${field} changed to ${value}`);
        setPolicy((prevPolicy: any) => ({
            ...prevPolicy,
            insuranceCompanyId: value
        }));

        setPolicy((prevPolicy: any) => ({
            ...prevPolicy,
            insuranceCompany: {
                ...prevPolicy.insuranceCompany,
                id: value,
            }
        }));

        if (value && policy.policyAdditionDetails && policy.policyAdditionDetails.vehiclePolicyType) {
            // use api to get list of branches by insurance company id and policy type
            createDateListOfBranches(policy.policyType.policyTypeId, Number(policy.policyAdditionDetails.vehiclePolicyType));
        }
    }

    const onAccidentDetailsVehicleChange = (field: string, value: any) => {
        // Handle accident details vehicle change logic here
        console.log(`Accident details vehicle field ${field} changed to ${value}`);
        // use api to get vehicle details by license number




        setPolicy((prevPolicy: any) => ({
            ...prevPolicy,
            policyAdditionDetails: {
                vehicle: {
                    ...prevPolicy.policyAdditionDetails.vehicle,
                    [field]: value
                }
            }
        }));
    };


    const getVehicleDetails = async (event: any) => {

        var _licenseNumber = event.currentTarget.value.trim();

        if (_licenseNumber.length > 0) {
            var res = await new SubscribersModel().RiderCheckActiveVehicle(_licenseNumber);
            console.log('getVehicleDetails-res', res);

            setLicenseNumberLoading(true);

            // const _vehicle: VehicleDetailsData = new VehicleDetailsData();
            var data = await new SimulatorModel().getVehicleDetailsByLicenseNumber(_licenseNumber);
            console.log('getVehicleDetails-data', data)
            // 
            // if (data && data.LeviItzhak) {
            //     setVehicleData(data.LeviItzhak, _licenseNumber, false);

            // } else {
            //     setModelCode('');
            //     setVehicle(null);
            //     HandleVehicleValidation(false);
            // }
            setLicenseNumberLoading(false);
        }

    }

    const getPremia = () => {
        if (policy.itemType === 'policy') {
            return policy.policyAdditionDetails.premiumSum;
        } else if (policy.itemType === 'rider') {
            // If it's a rider, calculate the total customer cost from riderPackages
            if (policy.riderPackages && policy.riderPackages.length > 0) {
                let totalCustomerCost: number = 0;
                policy.riderPackages.forEach((p: any) => {
                    totalCustomerCost += p.customerCost
                })
                return totalCustomerCost;

            } else {
                return "";
            }
        }
        return "";
    };

    const onPrimaryDetailsChange = (field: string, value: any) => {
        // Handle primary details change logic here
        console.log(`Primary details field ${field} changed to ${value}`);
        setPolicy((prevPolicy: any) => ({
            ...prevPolicy,
            [field]: value
        }));
    };

    const onAdditionNumberChange = (field: string, value: any) => {
        // Handle addition number change logic here
        const numericValue = value.replace(/\D/g, '');
        setPolicy((prevPolicy: any) => ({
            ...prevPolicy,
            policyAdditionDetails: {
                ...prevPolicy.policyAdditionDetails,
                [field]: numericValue
            }
        }));

    }

    const onChangeStartDate = (field: string, value: Date | null) => {
        // Handle date change logic here
        if (value === null) return;
        if (policy.extensionStartDate && moment(policy.extensionStartDate).format('DD-MM-YYYY') != "01-01-0001") {
            setPolicy((prevPolicy: any) => ({
                ...prevPolicy,
                extensionStartDate: value
            }));
        } else {
            setPolicy((prevPolicy: any) => ({
                ...prevPolicy,
                [field]: value
            }));
        }
    }

    const onChangeEndDate = (field: string, value: Date | null) => {
        // Handle date change logic here
        if (value === null) return;
        if (policy.extensionEndDate && moment(policy.extensionEndDate).format('DD-MM-YYYY') != "01-01-0001") {
            setPolicy((prevPolicy: any) => ({
                ...prevPolicy,
                extensionEndDate: value
            }));
        } else {
            setPolicy((prevPolicy: any) => ({
                ...prevPolicy,
                [field]: value
            }));
        }
    }

    const getLastCompany = (lastCompanyId: string): string => {
        const insuranceCompanies = localStorage.getItem('insuranceCompanies');
        if (!insuranceCompanies) {
            return 'לא צויין';
        }
        const companies = JSON.parse(insuranceCompanies);
        if (!companies || !Array.isArray(companies) || companies.length === 0) {
            return 'לא צויין';
        }
        const lastCompany = companies.find((company: any) => company.id === lastCompanyId);
        if (!lastCompany) {
            return 'לא צויין';
        }
        if (lastCompany.name && lastCompany.name.length > 0) {
            return lastCompany.name;
        }
        return lastCompanyId ? lastCompanyId : 'לא צויין';
    }

    //////////////////// age young driver customer ///////////////////////////

    const onYoungDriverCustomerAgeChange = (field: string, value: Date) => {

        // Handle additional young driver customer details change logic here
        console.log(`Additional young driver customer field ${field} changed to ${value}`);
        const newPolicy = { ...policy };
        // Update the policy state with the new age value
        const additionDetails = newPolicy.policyAdditionDetails || {};

        additionDetails[field] = value
        newPolicy.policyAdditionDetails = additionDetails;
        // Update the policy state
        setPolicy(newPolicy);
        onYoungDriverAgeChange(value);

    }

    const onYoungDriverAgeChange = (date: any) => {
        // Handle additional young driver customer details change logic here
        if (date) {
            const dateOfBirth = new Date(date);
            const today = new Date(policy.policyAdditionDetails.startDate);
            let age = today.getFullYear() - dateOfBirth.getFullYear();
            const m = today.getMonth() - dateOfBirth.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < dateOfBirth.getDate())) {
                age--;
            }
            setAgeYoungDriver(age);
        }
    }

    /////////////////// age of main driver customer ////////////////////

    const onMainDriverCustomerAgeChange = (field: string, value: any) => {
        // Handle additional young driver customer details change logic here
        console.log(`Additional young driver customer field ${field} changed to ${value}`);
        const newPolicy = { ...policy };
        // Update the policy state with the new age value
        const additionDetails = newPolicy.policyAdditionDetails || {};

        additionDetails[field] = value
        newPolicy.policyAdditionDetails = additionDetails;
        // Update the policy state
        setPolicy(newPolicy);
        onMainDriverAgeChange(value);
    }

    const onMainDriverAgeChange = (date: any) => {
        // Handle additional young driver customer details change logic here
        if (date) {
            const dateOfBirth = new Date(date);
            const today = new Date(policy.policyAdditionDetails.startDate);
            let age = today.getFullYear() - dateOfBirth.getFullYear();
            const m = today.getMonth() - dateOfBirth.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < dateOfBirth.getDate())) {
                age--;
            }
            setAgeMainDriver(age);
        }
    }

    ////////////////////////////////////////////////////////



    //////////////////// set young seniority ///////////////////////////

    const onYoungDriverCustomerSeniorityChange = (field: string, value: Date) => {
        // Handle additional young driver customer details change logic here
        console.log(`Additional young driver customer field ${field} changed to ${value}`);

        setDriverYoungSeniorityDate(value);
        if (value) {
            const dateOfBirth = new Date(value);
            const today = new Date(policy.policyAdditionDetails.startDate);
            let age = today.getFullYear() - dateOfBirth.getFullYear();
            const m = today.getMonth() - dateOfBirth.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < dateOfBirth.getDate())) {
                age--;
            }
            const newPolicy = { ...policy };
            // Update the policy state with the new age value
            const additionDetails = newPolicy.policyAdditionDetails || {};

            additionDetails.driverMainSeniorityDate = value
            additionDetails.driverMainSeniority = Number(age);
            newPolicy.policyAdditionDetails = additionDetails;
            // Update the policy state
            setPolicy(newPolicy);
            setDriverYoungSeniority(age);
        }
    }

    //////////////////// set main seniority ///////////////////////////

    const onMainDriverCustomerSeniorityChange = (field: string, value: Date) => {
        // Handle additional young driver customer details change logic here
        console.log(`Additional young driver customer field ${field} changed to ${value}`);
        setDriverMainSeniorityDate(value);
        if (value) {
            const dateOfBirth = new Date(value);
            const today = new Date(policy.policyAdditionDetails.startDate);
            let age = today.getFullYear() - dateOfBirth.getFullYear();
            const m = today.getMonth() - dateOfBirth.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < dateOfBirth.getDate())) {
                age--;
            }
            const newPolicy = { ...policy };
            // Update the policy state with the new age value
            const additionDetails = newPolicy.policyAdditionDetails || {};


            additionDetails["driverMainSeniorityDate"] = value
            additionDetails[field] = Number(age);
            newPolicy.policyAdditionDetails = additionDetails;
            // Update the policy state
            setPolicy(newPolicy);
            setDriverMainSeniority(age);
        }
    }

    /////////////////////////////////////////////////

    const onSave = async (e: any) => {
        e.preventDefault(); // Prevent default form submission behavior
        // Handle save logic here
        console.log('Saving policy details:', policy);
        const user = localStorage.getItem('loggedUser');
        const policyToSave = { ...policy };
        // set nul on route in addition details if routeId is 0

        policyToSave.policyAdditionDetails.route = null;
        // You can add your save logic here, such as making an API call to save the updated policy
        try {
            setEdit(false);
            let res = await customerModel.policyUpdatePolicy(policy);
            console.log('res', res)
            if (res) {
                console.log('Policy updated successfully:', res);
                // Optionally, you can update the state or show a success message
            }

        } catch (error) {
            console.error('Error updating policy:', error);
            // Optionally, you can show an error message to the user
        } finally {
            // Reset the old policy to the current policy after saving
            setShowPopUp(true);
        }

        // setOldPolicy(policy);
    }

    const onCancel = () => {
        // Handle cancel logic here
        console.log('Canceling changes');
        setPolicy(oldPolicy);
        setEdit(false);
    }

    const getCreatorIfo = (creatorUserId: string) => {
        const users = localStorage.getItem('usersList');
        if (!users) {
            return '';
        }
        const usersList = JSON.parse(users);
        if (!usersList || !Array.isArray(usersList) || usersList.length === 0) {
            return '';
        }
        const creatorUser = usersList.find((user: any) => user.id === creatorUserId);
        if (!creatorUser) {
            return '';
        }
        if (creatorUser.fullName && creatorUser.fullName.length > 0) {
            return creatorUser.fullName;
        }
        return creatorUserId ? creatorUserId : '';
    }

    const onChangeDriverDetails = (e: any) => {
        const { name, value } = e.target;
        console.log(`Driver details field ${name} changed to ${value}`);
        setPolicy((prevPolicy: any) => ({
            ...prevPolicy,
            policyAdditionDetails: {
                ...prevPolicy.policyAdditionDetails,
                [name]: value
            }
        }));
    }

    const onChangeDriverYoungGenderDetails = (value: string) => {
        setPolicy((prevPolicy: any) => ({
            ...prevPolicy,
            policyAdditionDetails: {
                ...prevPolicy.policyAdditionDetails,
                driverYoungGender: Number(value)
            }
        }));
    }

    const onChangeDriverMainGenderDetails = (value: string) => {
        setPolicy((prevPolicy: any) => ({
            ...prevPolicy,
            policyAdditionDetails: {
                ...prevPolicy.policyAdditionDetails,
                driverMainGender: Number(value)
            }
        }));
    }

    const getUserInfo = (userId: string) => {
        const users = localStorage.getItem('usersList');
        if (!users) {
            return 'לא ידוע';
        }
        const usersList = JSON.parse(users);
        const user = usersList.find((u: any) => u.id === userId);
        if (user && user.fullName && user.fullName.length > 0) {
            return user.fullName;
        }
        return 'לא ידוע';
    }

    const getGenderLabel = (value: any): string => {
        if (value === undefined || value === null) {
            return '';
        }
        const g = genders.find((g: any) => g.value === value)
        return g ? g.label : '';
    }




    return (
        <>
            {
                showPopUp &&
                <MessegePopupClient
                    onClose={() => setShowPopUp(false)}
                />
            }
            <div className="details-row" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: '35px' }}>
                <div className="row-title">
                    פרטי הפוליסה
                </div>

                {/* {!edit && (
                    <div className='btn-section-warper'>
                        <button className='btn-style' onClick={() => setEdit(true)}>
                            עריכה
                        </button>
                    </div>
                )}

                {edit && (
                    <div className='btn-section-warper'>
                        <button className='btn-style' onClick={onSave}>
                            שמירה
                        </button>
                        <button className='btn-style-cancel' onClick={onCancel}>
                            ביטול
                        </button>
                    </div>
                )} */}
            </div>
            <div className='wapper-policy' style={{ borderBottom: '1px solid #9399b7' }}>
                <div className="row-items-details white-bg">
                    <div className="row-sub-title">
                        כללי
                    </div>
                    <div className="policy-main-details" style={{ display: 'flex', justifyContent: 'flex-start', gap: '50px' }}>
                        <div className="cell">
                            <div className="title">
                                שם מבוטח
                            </div>
                            <div className="description cell-value">
                                {policyData['fullName']}
                            </div>
                        </div>
                        <div className="cell">
                            <div className="title">
                                סוג אירוע
                            </div>
                            <div className="description cell-value">
                                {/* {eventTypes[policyData['eventType']] && eventTypes[policyData['eventType']].description ? eventTypes[policyData['eventType']].description : ''} */}
                                <IDNameDescriptionItemSelect
                                    Disabled={!edit}
                                    OnChange={onAdditionalDetailsChange}
                                    Id={"eventType"} Options={eventTypes}
                                    Value={policy.policyAdditionDetails && policy.policyAdditionDetails.eventType >= 0 ? policy.policyAdditionDetails.eventType : ''}
                                />
                            </div>
                        </div>
                        <div className="cell">
                            <div className="title">
                                תאריך אירוע
                            </div>
                            <div className="description cell-value">
                                {/* {policyData['eventDate']} */}
                                <CompDatePicker
                                    disabled={!edit}
                                    placeholder={'תאריך אירוע'}
                                    value={policy.policyAdditionDetails && policy.policyAdditionDetails.eventDate ? new Date(policy.policyAdditionDetails.eventDate) : null}
                                    onChange={(date: Date | null) => {
                                        onAdditionalDetailsChange('eventDate', date);
                                    }}
                                />
                            </div>
                        </div>

                        <div className="cell">
                            <div className="title">
                                מספר תוספת
                            </div>
                            <div className="description cell-value">
                                <PolicyInput type='text'
                                    value={policy?.additionNumber ? policy.additionNumber : ''}
                                    onChange={(e) => onPrimaryDetailsChange('additionNumber', e.target.value)}
                                    disabled={!edit}
                                    style={{ marginLeft: '10px', width: '120px' }}
                                />

                            </div>
                        </div>

                        <div className="cell">
                            <div className="title">
                                מספר פוליסה
                            </div>
                            <div className="description cell-value">
                                <PolicyInput type='text'
                                    value={policy.policyNumber}
                                    onChange={(e) => onPrimaryDetailsChange('policyNumber', e.target.value)}
                                    disabled={!edit}
                                    style={{ marginLeft: '10px', width: '120px' }}
                                />

                            </div>
                        </div>
                        <div className="cell">
                            <div className="title">
                                חברת ביטוח
                            </div>
                            <div className="description cell-value">
                                {/* {getLastCompany(policy.policyAdditionDetails && policy.policyAdditionDetails.lastCompanyId)} */}
                                <IDNameDescriptionItemSelect
                                    Disabled={!edit}
                                    OnChange={onInsuranceCompanyChange}
                                    Options={insuranceCompanies}
                                    Id={"insuranceCompanyId"}
                                    Value={policy.insuranceCompanyId}
                                />
                            </div>
                        </div>

                        <div className="cell">
                            <div className="title">
                                סוג ביטוח
                            </div>
                            <div className="description cell-value">
                                <IDNameDescriptionItemSelect
                                    Disabled={!edit}
                                    OnChange={onAdditionalDetailsChangeInsuranceType}
                                    Options={policyTypes}
                                    Id={"vehiclePolicyType"}
                                    Value={policy.policyAdditionDetails && policy.policyAdditionDetails.vehiclePolicyType ? policy.policyAdditionDetails.vehiclePolicyType : ""}
                                />
                            </div>
                        </div>


                        <div className="cell">
                            <div className="title">
                                שם ענף
                            </div>
                            <div className="description cell-value">

                                <Select
                                    disabled={!edit}
                                    value={policy.policyAdditionDetails && policy.policyAdditionDetails.route && policy.policyAdditionDetails.route.routeId >= 0 ?
                                        policy.policyAdditionDetails.route.routeId : 0}
                                    onChange={onAdditionalDetailsChangeRoute}
                                    style={{ marginLeft: '10px', width: '180px', padding: '5px', }}
                                >
                                    {branchesList && branchesList.length > 0 && branchesList.map((route: any, index: number) => (
                                        // route.compulsoryRouteId ?
                                        // <option key={index} value={route.compulsoryRouteId} >{route.compulsoryRouteId} - {route.name}</option>
                                        // :
                                        <option key={index} value={route.routeId} >{route.routeId} - {route.comment}</option>
                                    ))}
                                </Select>

                            </div>
                        </div>
                        <div className="cell">
                            <div className="title">
                                מספר סוכן
                            </div>
                            <div className="description cell-value">
                                <PolicyInput type='text'
                                    onChange={(e) => {
                                        setPolicy((prevPolicy: any) => ({
                                            ...prevPolicy,
                                            agentDetails: {
                                                ...prevPolicy.agentDetails,
                                                agentNumber: e.target.value
                                            }
                                        }))
                                    }}
                                    value={policy.agentDetails && policy.agentDetails.agentNumber}
                                    disabled={!edit}
                                    style={{ marginLeft: '10px', width: '120px' }}
                                />


                            </div>
                        </div>
                    </div>
                </div>

                <div className="details-row white-bg">

                    <div className="policy-main-details" style={{ display: 'flex', justifyContent: 'flex-start', gap: '50px' }}>

                        <div className="cell">
                            <div className="title">
                                תאריך תחילה
                            </div>
                            <div className="description cell-value">
                                <CompDatePicker
                                    disabled={!edit}
                                    placeholder={'תאריך תחילה'}
                                    value={policy.extensionStartDate && moment(policy.extensionStartDate).format('DD-MM-YYYY') != "01-01-0001" ? new Date(policy.startDate) :
                                        policy.startDate ? new Date(policy.startDate) : null}
                                    onChange={(date: Date | null) => {
                                        onChangeStartDate('startDate', date);
                                    }}
                                />
                            </div>
                        </div>

                        <div className="cell">
                            <div className="title">
                                תאריך סיום
                            </div>
                            <div className="description cell-value">
                                <CompDatePicker
                                    disabled={!edit}
                                    placeholder={'תאריך סיום'}
                                    value={policy.extensionEndDate && moment(policy.extensionEndDate).format('DD-MM-YYYY') != "01-01-0001" ? new Date(policy.endDate) :
                                        policy.endDate ? new Date(policy.endDate) : null}
                                    onChange={(date: Date | null) => {
                                        onChangeEndDate('endDate', date);
                                    }}
                                />
                            </div>
                        </div>
                        <div className="cell">
                            <div className="title">
                                חברה קודמת
                            </div>
                            <div className="description cell-value">
                                {/* {getLastCompany(policy.policyAdditionDetails && policy.policyAdditionDetails.lastCompanyId)} */}
                                <IDNameDescriptionItemSelect
                                    Disabled={!edit}
                                    OnChange={onAdditionalDetailsChange}
                                    Options={insuranceCompanies}
                                    Id={"lastCompanyId"}
                                    Value={policy.policyAdditionDetails && policy.policyAdditionDetails.lastCompanyId}
                                />

                            </div>
                        </div>
                    </div>


                </div>

                <div className="details-row white-bg">
                    <div className="row-sub-title">
                        פרטי הרכב
                    </div>
                    <div className="policy-main-details" style={{ display: 'flex', justifyContent: 'flex-start', gap: '50px' }}>
                        <div className="cell">
                            <div className="title">
                                מספר רישוי
                            </div>
                            <div className="description cell-value">
                                {/* {policyData['licenseNumber']} */}
                                <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                    <PolicyInput type='text'
                                        value={policy.policyAdditionDetails && policy.policyAdditionDetails.vehicle &&
                                            policy.policyAdditionDetails.vehicle.licenseNumber ? policy.policyAdditionDetails.vehicle.licenseNumber : ''}
                                        onChange={(e) => onAccidentDetailsVehicleChange('licenseNumber', e.target.value)}
                                        onBlur={(e: any) => getVehicleDetails(e)}
                                        disabled={!edit}
                                        style={{ marginLeft: '10px', width: '120px' }}
                                    />
                                    <img src={require("../../assets/images/loading.gif")} className={licenseNumberLoading ? "loadingGif" : "hide"} />

                                </div>
                            </div>
                        </div>
                        <div className="cell">
                            <div className="title">
                                קוד דגם
                            </div>
                            <div className="description cell-value">
                                {policyData['modelCode']}
                            </div>
                        </div>
                        <div className="cell">
                            <div className="title">
                                שנת יצור
                            </div>
                            <div className="description cell-value">
                                {policyData['carYear']}
                            </div>
                        </div>
                        <div className="cell">
                            <div className="title">
                                סוג הרכב
                            </div>
                            <div className="description cell-value">
                                פרטי
                            </div>
                        </div>

                        <div className="cell">
                            <div className="title">
                                משקל/נפח
                            </div>
                            <div className="description cell-value">
                                {policyData['weightVolume']}
                            </div>
                        </div>

                        <div className="cell">
                            <div className="title">
                                דגם
                            </div>
                            <div className="description cell-value">
                                {policyData['vehicleSubModel']}
                            </div>
                        </div>
                        <div className="cell">
                            <div className="title">
                                הנעה
                            </div>
                            <div className="description cell-value">
                                {policyData['gearsType']}
                            </div>
                        </div>
                        <div className="cell">
                            <div className="title">
                                בעלות הרכב
                            </div>
                            <div className="description cell-value">
                                {/* {policyData['vehicleOwnership']} */}
                                {vehicleOwnership[policyData['vehicleOwnership']] && vehicleOwnership[policyData['vehicleOwnership']].description ? vehicleOwnership[policyData['vehicleOwnership']].description : ''}
                            </div>

                        </div>
                        {policy.policyAdditionDetails && policy.policyAdditionDetails.vehiclePolicyType && policy.policyAdditionDetails.vehiclePolicyType != 6 &&
                            <div className="cell">
                                <div className="title">
                                    רמת מיגון
                                </div>
                                <div className="description cell-value">
                                    <input
                                        type="number"
                                        disabled={!edit}
                                        value={policy.policyAdditionDetails && policy.policyAdditionDetails.protection >= 0 ? policy.policyAdditionDetails.protection : ""}
                                        onChange={(e: any) => onAdditionalDetailsChange("protection", Number(e.target.value))}
                                    />
                                </div>
                            </div>
                        }
                    </div>
                </div>

                <div className='white-bg flex-space-between'>
                    <div className="details-row white-bg flex-grow">
                        <div className="row-sub-title">
                            פרטי נהגים
                        </div>
                        <div className="policy-main-details">
                            <div className="cell fixed-width">
                                <div className="title">
                                    רשאים לנהוג
                                </div>
                                <div className="description cell-value">
                                    <IDNameDescriptionItemSelect
                                        Disabled={!edit}
                                        OnChange={onChangeAuthorizedToDrive}
                                        Options={authorizedToDrive}
                                        Id={"driversType"}
                                        Value={policy.policyAdditionDetails && policy.policyAdditionDetails.driversType}
                                    />
                                </div>
                            </div>
                            {policy.policyAdditionDetails && policy.policyAdditionDetails.driversType > 0 &&
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '50px' }}>
                                    {policyData['authorizedToDrive'] < 2 &&
                                        <>
                                            <div className="cell fixed-width">
                                                <div className="title">
                                                    שם מלא
                                                </div>
                                                <div className='description cell-value'>
                                                    <input type="text" name='driverYoungFirstName'
                                                        value={policy.policyAdditionDetails && (policy.policyAdditionDetails.driverYoungFirstName) ? policy.policyAdditionDetails.driverYoungFirstName : ''}
                                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChangeDriverDetails(e)}
                                                        disabled={!edit} />
                                                    <input type="text" name='driverYoungLastName'
                                                        value={policy.policyAdditionDetails && (policy.policyAdditionDetails.driverYoungLastName) ? policy.policyAdditionDetails.driverYoungLastName : ''}
                                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChangeDriverDetails(e)}
                                                        disabled={!edit} />
                                                </div>
                                            </div>

                                            <div className="cell fixed-width">
                                                <div className="title">
                                                    ת.ז. נהג צעיר
                                                </div>
                                                <div className='description cell-value'>
                                                    <input type="text" name='driverYoungIdentifier' value={policy.policyAdditionDetails && policy.policyAdditionDetails.driverYoungIdentifier
                                                        ? policy.policyAdditionDetails.driverYoungIdentifier : ''}
                                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChangeDriverDetails(e)}
                                                        disabled={!edit} />
                                                </div>
                                            </div>
                                            <div className="cell fixed-width">
                                                <div className="title">
                                                    מגדר
                                                </div>
                                                <Select
                                                    placeholder="מגדר"
                                                    value={policy.policyAdditionDetails && policy.policyAdditionDetails.driverYoungGender
                                                        && policy.policyAdditionDetails.driverYoungGender >= 0 ? String(policy.policyAdditionDetails.driverYoungGender) : undefined}
                                                    onChange={onChangeDriverYoungGenderDetails}
                                                    style={{ width: '100%' }}
                                                    disabled={!edit}
                                                    options={genders}
                                                />
                                            </div>
                                        </>
                                    }



                                    <div className="cell fixed-width">
                                        <div className="title">
                                            גיל הנהג הצעיר
                                        </div>
                                        <div className="description cell-value" style={{ display: 'flex', gap: '10px' }}>

                                            <CompDatePicker disabled={!edit} placeholder={'גיל הנהג הצעיר'} value={policy.policyAdditionDetails && policy.policyAdditionDetails.driverYoungBirthDate
                                                ? policy.policyAdditionDetails.driverYoungBirthDate : ''}
                                                onChange={(date: Date) => onYoungDriverCustomerAgeChange("driverYoungBirthDate", date)} />

                                            {ageYoungDriver}
                                        </div>
                                    </div>


                                    <div className="cell fixed-width">
                                        <div className="title">
                                            ותק הנהג הצעיר
                                        </div>
                                        <div className="description cell-value" style={{ display: 'flex', gap: '10px' }}>

                                            <CompDatePicker disabled={!edit} placeholder={'ותק הנהג הצעיר'} value={driverYoungSeniorityDate}
                                                onChange={(date: Date) => onYoungDriverCustomerSeniorityChange("driverYoungSeniorityDate", date)} />
                                            {driverYoungSeniority}

                                        </div>
                                    </div>
                                </div>
                            }
                            {policy.policyAdditionDetails && policy.policyAdditionDetails.driversType < 2 &&
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '50px' }}>

                                    <div className="cell fixed-width">
                                        <div className="title">
                                            שם מלא
                                        </div>
                                        <div className='description cell-value'>
                                            <input type="text" name='driverMainFirstName'
                                                value={policy.policyAdditionDetails && (policy.policyAdditionDetails.driverMainFirstName) ? policy.policyAdditionDetails.driverMainFirstName : ''}
                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChangeDriverDetails(e)}
                                                disabled={!edit} />

                                            <input type="text" name='driverMainLastName'
                                                value={policy.policyAdditionDetails && (policy.policyAdditionDetails.driverMainLastName) ? policy.policyAdditionDetails.driverMainLastName : ''}
                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChangeDriverDetails(e)}
                                                disabled={!edit} />

                                        </div>
                                    </div>


                                    <div className="cell fixed-width">
                                        <div className="title">
                                            ת.ז. נהג עיקרי
                                        </div>
                                        <div className='description cell-value'>
                                            <input type="text" name='driverMainIdentifier' value={policy.policyAdditionDetails && policy.policyAdditionDetails.driverMainIdentifier
                                                ? policy.policyAdditionDetails.driverMainIdentifier : ''}
                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChangeDriverDetails(e)}
                                                disabled={!edit} />
                                        </div>
                                    </div>
                                    <div className="cell fixed-width">
                                        <div className="title">
                                            מגדר
                                        </div>
                                        <Select
                                            style={{ width: '100%' }}
                                            placeholder="מגדר"
                                            value={policy.policyAdditionDetails && policy.policyAdditionDetails.driverMainGender >= 0 ? String(policy.policyAdditionDetails.driverMainGender) : undefined}
                                            onChange={onChangeDriverMainGenderDetails}
                                            disabled={!edit}
                                            options={genders}
                                        />

                                    </div>
                                    <div className="cell fixed-width">
                                        <div className="title">
                                            גיל נהג עיקרי
                                        </div>
                                        <div className="description cell-value" style={{ display: 'flex', gap: '10px' }}>

                                            <CompDatePicker disabled={!edit} placeholder={'גיל הנהג עיקרי'} value={policy.policyAdditionDetails && policy.policyAdditionDetails.driverMainBirthDate ?
                                                policy.policyAdditionDetails.driverMainBirthDate : ''}
                                                onChange={(date: Date) => onMainDriverCustomerAgeChange("driverMainBirthDate", date)} />
                                            {ageMainDriver}

                                        </div>
                                    </div>
                                    <div className="cell fixed-width">
                                        <div className="title">
                                            ותק נהג עיקרי
                                        </div>
                                        <div className="description cell-value" style={{ display: 'flex', gap: '10px' }}>

                                            <CompDatePicker disabled={!edit} placeholder={'ותק נהג עיקרי'} value={driverMainSeniorityDate}
                                                onChange={(date: Date) => onMainDriverCustomerSeniorityChange("driverMainSeniority", date)} />
                                            {driverMainSeniority}
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>

                <div className='white-bg flex-space-between'>
                    <div className="details-row white-bg flex-grow">
                        <div className="row-sub-title">
                            עבר ביטוחי
                        </div>
                        <div className="policy-main-details" style={{ display: 'flex', flexWrap: 'wrap', gap: '30px' }}>
                            <div className="cell fixed-width">
                                <div className="title">
                                    שנה קודמת
                                </div>
                                <div className="description cell-value">
                                    <IDNameDescriptionItemSelect
                                        Disabled={!edit}
                                        OnChange={onAdditionalDetailsChange}
                                        Options={passedTypeOfInsurance}
                                        Id={"passedInsuranceTypeLastYear"}
                                        Value={policy.policyAdditionDetails && policy.policyAdditionDetails.passedInsuranceTypeLastYear}
                                    />
                                </div>
                            </div>
                            <div className="cell fixed-width">
                                <div className="title">
                                    תביעות
                                </div>
                                <div className="description cell-value">

                                    <PolicyInput type='number'
                                        value={policy.policyAdditionDetails && policy.policyAdditionDetails.sueNumber1 >= 0 ?
                                            policy.policyAdditionDetails.sueNumber1 : 0}
                                        onChange={(e) => onAdditionalDetailsChange('sueNumber1', Number(e.target.value))}
                                        disabled={!edit}
                                        style={{ marginLeft: '10px', width: '60px' }}
                                    />
                                </div>
                            </div>
                            {/* <div className="cell fixed-width">
                        </div> */}

                            <div className="cell fixed-width">
                                <div className="title">
                                    שנתיים קודמות
                                </div>
                                <div className="description cell-value">
                                    <IDNameDescriptionItemSelect
                                        Disabled={!edit}
                                        OnChange={onAdditionalDetailsChange}
                                        Options={passedTypeOfInsurance}
                                        Id={"passedInsuranceType2YearsAgo"}
                                        Value={policy.policyAdditionDetails && policy.policyAdditionDetails.passedInsuranceType2YearsAgo}
                                    />
                                </div>
                            </div>
                            <div className="cell fixed-width">
                                <div className="title">
                                    תביעות
                                </div>
                                <div className="description cell-value">

                                    <PolicyInput type='number'
                                        value={policy.policyAdditionDetails && policy.policyAdditionDetails.sueNumber2 >= 0 ?
                                            policy.policyAdditionDetails.sueNumber2 : 0}
                                        onChange={(e) => onAdditionalDetailsChange('sueNumber2', Number(e.target.value))}
                                        disabled={!edit}
                                        style={{ marginLeft: '10px', width: '60px' }}
                                    />
                                </div>

                            </div>


                            <div className="cell fixed-width" >
                                <div className="title">
                                    שלוש שנים קודמות
                                </div>
                                <div className="description cell-value">
                                    <IDNameDescriptionItemSelect
                                        Disabled={!edit}
                                        OnChange={onAdditionalDetailsChange}
                                        Options={passedTypeOfInsurance}
                                        Id={"passedInsuranceType3YearsAgo"}
                                        Value={policy.policyAdditionDetails && policy.policyAdditionDetails.passedInsuranceType3YearsAgo}
                                    />
                                </div>
                            </div>
                            <div className="cell fixed-width">
                                <div className="title">
                                    תביעות
                                </div>
                                <div className="description cell-value">
                                    <PolicyInput type='number'
                                        value={policy.policyAdditionDetails && policy.policyAdditionDetails.sueNumber3 >= 0 ?
                                            policy.policyAdditionDetails.sueNumber3 : 0}
                                        onChange={(e) => onAdditionalDetailsChange('sueNumber3', Number(e.target.value))}
                                        disabled={!edit}
                                        style={{ marginLeft: '10px', width: '60px' }}
                                    />
                                </div>
                            </div>

                            <div className="cell fixed-width">
                                <div className="title">
                                    תביעות גוף
                                </div>
                                <div className="description cell-value">
                                    <PolicyInput type='number'
                                        value={policy.policyAdditionDetails && policy.policyAdditionDetails.bodyClaimsAmount >= 0 ?
                                            policy.policyAdditionDetails.bodyClaimsAmount : 0}
                                        onChange={(e) => onAdditionalDetailsChange('bodyClaimsAmount', Number(e.target.value))}
                                        disabled={!edit}
                                        style={{ marginLeft: '10px', width: '60px' }}
                                    />
                                </div>
                            </div>

                            <div className="cell fixed-width">
                                <div className="title">
                                    שלילות
                                </div>
                                <div className="description cell-value">
                                    <PolicyInput type='number'
                                        value={policy.policyAdditionDetails && policy.policyAdditionDetails.revocationsAmount >= 0 ?
                                            policy.policyAdditionDetails.revocationsAmount : 0}
                                        onChange={(e) => onAdditionalDetailsChange('revocationsAmount', Number(e.target.value))}
                                        disabled={!edit}
                                        style={{ marginLeft: '10px', width: '60px' }}
                                    />
                                </div>
                            </div>


                            <div className="cell fixed-width">
                                <div className="title">
                                    נוסע בשבת
                                </div>
                                <div className="description cell-value">
                                    <CheckBox
                                        disabled={!edit}
                                        checked={policy.policyAdditionDetails && policy.policyAdditionDetails.drivingOnShabbat ? policy.policyAdditionDetails.drivingOnShabbat : false}
                                        onChange={(e: any) => onChangeCheckBox('drivingOnShabbat', e.target.checked)}
                                    />
                                </div>
                            </div>

                            <div className="cell fixed-width">
                                <div className="title">
                                    כינון אוטומטי
                                </div>
                                <div className="description cell-value">
                                    <CheckBox
                                        disabled={!edit}
                                        checked={policy.policyAdditionDetails && policy.policyAdditionDetails.autodirection ? policy.policyAdditionDetails.autodirection : false}
                                        onChange={(e: any) => onChangeCheckBox('autodirection', e.target.checked)}
                                    />
                                </div>
                            </div>

                            <div className="cell fixed-width">
                                <div className='title'>
                                    חדש תמורת ישן
                                </div>
                                <CheckBox
                                    disabled={!edit}
                                    checked={policy.policyAdditionDetails && policy.policyAdditionDetails.newForOld ? policy.policyAdditionDetails.newForOld : false}
                                    onChange={(e: any) => onChangeCheckBox('newForOld', e.target.checked)}
                                />
                            </div>
                        </div>
                    </div>
                </div>



                <div className='white-bg flex-space-between'>
                    <div className="details-row white-bg flex-grow">
                        <div className="row-sub-title">
                            גביה
                        </div>
                        <div className="policy-main-details" style={{ display: 'flex', justifyContent: 'flex-start', gap: '30px' }}>
                            <div className="cell fixed-width">
                                <div className="title">
                                    פרמיה לתשלום
                                </div>
                                <div className="description cell-value">
                                    {getPremia()}
                                </div>
                            </div>
                            <div className="cell fixed-width">
                                <div className="title">
                                    מטבע
                                </div>
                                <div className="description cell-value">
                                    ₪
                                </div>
                            </div>
                            <div className="cell fixed-width">
                                <div className="title">
                                    שיטת גביה
                                </div>
                                <div className="description cell-value">
                                    <IDNameDescriptionItemSelect
                                        Disabled={!edit}
                                        OnChange={onAdditionalDetailsChange}
                                        Id={"collectionMethodType"} Options={collectionMethodtype}
                                        Value={policy.policyAdditionDetails && policy.policyAdditionDetails.collectionMethodType >= 0 ?
                                            policy.policyAdditionDetails.collectionMethodType : ''}
                                    />
                                </div>
                            </div>
                            <div className="cell fixed-width">
                                <div className="title">
                                    מסלול גביה
                                </div>
                                <div className="description cell-value">
                                    <IDNameDescriptionItemSelect
                                        Disabled={!edit}
                                        OnChange={onAdditionalDetailsChange}
                                        Id={"collectionRouteType"} Options={collectionRouteType}
                                        Value={policy.policyAdditionDetails && policy.policyAdditionDetails.collectionRouteType >= 0 ?
                                            policy.policyAdditionDetails.collectionRouteType : ''}
                                    />
                                </div>
                            </div>
                            <div className="cell fixed-width">
                                <div className="title">
                                    תשלומים
                                </div>
                                <div className="description cell-value">
                                    {/* <input type="number" value={policy.policyAdditionDetails && policy.policyAdditionDetails.numberOfPayments}
                                        onChange={(e: any) => onAdditionalDetailsChange("numberOfPayments", e.target.value)} disabled={!edit} /> */}
                                    <PolicyInput type='number'
                                        value={policy.policyAdditionDetails && policy.policyAdditionDetails.numberOfPayments}
                                        onChange={(e) => onAdditionalDetailsChange("numberOfPayments", Number(e.target.value))}
                                        disabled={!edit}
                                        style={{ marginLeft: '10px', width: '60px' }}
                                    />

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="details-row white-bg flex-grow">
                        <div className="row-sub-title">
                            פרטי חשבון
                        </div>
                        <div className="policy-main-details" style={{ display: 'flex', justifyContent: 'flex-start', gap: '20px' }}>
                            <div className="cell fixed-width">
                                <div className="title">
                                    מספר חשבון
                                </div>
                                <div className="description cell-value">
                                    {/* <input type="text" value={policy.policyAdditionDetails && policy.policyAdditionDetails.bankAccountNumber}
                                        onChange={(e: any) => onAdditionalDetailsChange("bankAccountNumber", e.target.value)} disabled={!edit} /> */}
                                    <PolicyInput type='text'
                                        value={policy.policyAdditionDetails && policy.policyAdditionDetails.bankAccountNumber}
                                        onChange={(e) => onAdditionalDetailsChange("bankAccountNumber", e.target.value)}
                                        disabled={!edit}
                                        style={{ marginLeft: '10px', width: '120px' }}
                                    />

                                </div>
                            </div>
                            <div className="cell fixed-width">
                                <div className="title">
                                    בנק
                                </div>
                                <div className="description cell-value">
                                    {/* <input type="text" value={policy.policyAdditionDetails && policy.policyAdditionDetails.bankNumber}
                                        onChange={(e: any) => onAdditionalDetailsChange("bankNumber", e.target.value)} disabled={!edit} /> */}
                                    <PolicyInput type='text'
                                        value={policy.policyAdditionDetails && policy.policyAdditionDetails.bankNumber}
                                        onChange={(e) => onAdditionalDetailsChange("bankNumber", e.target.value)}
                                        disabled={!edit}
                                        style={{ marginLeft: '10px', width: '120px' }}
                                    />
                                </div>
                            </div>
                            <div className="cell fixed-width">
                                <div className="title">
                                    סניף
                                </div>
                                <div className="description cell-value">
                                    {/* <input type="text" value={policy.policyAdditionDetails && policy.policyAdditionDetails.bankBranchNumber}
                                        onChange={(e: any) => onAdditionalDetailsChange("bankBranchNumber", e.target.value)} disabled={!edit} /> */}
                                    <PolicyInput type='text'
                                        value={policy.policyAdditionDetails && policy.policyAdditionDetails.bankBranchNumber}
                                        onChange={(e) => onAdditionalDetailsChange("bankBranchNumber", e.target.value)}
                                        disabled={!edit}
                                        style={{ marginLeft: '10px', width: '120px' }}
                                    />
                                </div>
                            </div>
                            <div className="cell fixed-width">
                                <div className="title">
                                    שם בעל החשבון
                                </div>
                                <div className="description cell-value">
                                    {/* <input type="text" value={policy.policyAdditionDetails && policy.policyAdditionDetails.bankAccountOwner}
                                        onChange={(e: any) => onAdditionalDetailsChange("bankAccountOwner", e.target.value)} disabled={!edit} /> */}
                                    <PolicyInput type='text'
                                        value={policy.policyAdditionDetails && policy.policyAdditionDetails.bankAccountOwner}
                                        onChange={(e) => onAdditionalDetailsChange("bankAccountOwner", e.target.value)}
                                        disabled={!edit}
                                        style={{ marginLeft: '10px', width: '120px' }}
                                    />

                                </div>
                            </div>
                            <div className="cell fixed-width">
                                <div className="title">
                                    מספר התחייבות
                                </div>
                                <div className="description cell-value">
                                    {/* <input type="text" value={policy.policyAdditionDetails && policy.policyAdditionDetails.commitmentNumber} onChange={(e: any) => onAdditionalDetailsChange("commitmentNumber", e.target.value)} disabled={!edit} /> */}
                                    <PolicyInput type='text'
                                        value={policy.policyAdditionDetails && policy.policyAdditionDetails.commitmentNumber}
                                        onChange={(e) => onAdditionalDetailsChange("commitmentNumber", e.target.value)}
                                        disabled={!edit}
                                        style={{ marginLeft: '10px', width: '120px' }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='white-bg flex-space-between'>
                    <div className="details-row white-bg flex-grow">
                        <div className="row-sub-title">
                            פרטי אשראי
                        </div>

                        <div className="policy-main-details parameter-row">
                            <div className="parameter-item" style={{ maxWidth: '180px', minWidth: '180px' }}>
                                <div className="field">
                                    <div className="field-name">
                                        מספר כרטיס
                                    </div>
                                    <div className="value">
                                        <input type="text" id='ccNumber' onChange={(e: any) => setCCNumber(e.target.value)} value={getCCNumber()} placeholder='שדה חובה*' />
                                    </div>
                                </div>
                            </div>
                            <div className="parameter-item" style={{ maxWidth: '100px', minWidth: '100px' }}>
                                <div className="field">
                                    <div className="field-name">
                                        מס תשלומים
                                    </div>
                                    <div className="value">
                                        <select id="numberOfPayments" value={policy.numberOfPayments} onChange={(e) => onAdditionalDetailsChange("numberOfPayments", e.target.value)} className="select-input">
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                            <option value="4">4</option>
                                            <option value="5">5</option>
                                            <option value="6">6</option>
                                            <option value="7">7</option>
                                            <option value="8">8</option>
                                            <option value="9">9</option>
                                            <option value="10">10</option>
                                            <option value="11">11</option>
                                            <option value="12">12</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="parameter-item" style={{ maxWidth: '100px', minWidth: '100px' }}>
                                <div className="field">
                                    <div className="field-name">
                                        תוקף
                                    </div>
                                    <div className="value" >
                                        <input type="text" onChange={(e) => {
                                            let val = e.target.value.replace(/\D/g, ""); // keep only digits
                                            if (val.length > 2) {
                                                val = val.slice(0, 2) + "/" + val.slice(2, 4); // insert slash after 2 digits
                                            }
                                            setValidityDate(val);

                                        }} value={getValidityDate()} placeholder='שדה חובה*' />
                                    </div>
                                </div>
                            </div>
                            <div className="parameter-item" style={{ maxWidth: '100px', minWidth: '100px' }}>
                                <div className="field">
                                    <div className="field-name">
                                        CVV
                                    </div>
                                    <div className="value" >
                                        <input type="text" onChange={(e: any) => setCVV(e.target.value)} value={getCVV()} placeholder='שדה חובה*' />
                                    </div>
                                </div>
                            </div>
                            <div className="parameter-item" style={{ maxWidth: '150px', minWidth: '150px' }}>

                                <div className="field">
                                    <div className="field-name">
                                        ת. זהות
                                    </div>
                                    <div className="value" >
                                        <input type="text" onChange={(e: any) => setIdentity(e.target.value)} value={getIdentity()} placeholder='שדה חובה*' />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="parameter-row">
                            <div className="parameter-item" style={{ maxWidth: '180px', minWidth: '180px' }}>
                                <div className="field">
                                    <div className="field-name">
                                        שם מלא
                                    </div>
                                    <div className="value" >
                                        <input type="text" onChange={(e: any) => setPayerName(e.target.value)} value={getPayerName()} placeholder='שדה חובה*' />
                                    </div>
                                </div>
                            </div>
                            <div className="parameter-item" style={{ maxWidth: '180px', minWidth: '180px' }}>
                                <div className="field">
                                    <div className="field-name">
                                        טלפון
                                    </div>
                                    <div className="value">
                                        <input type="text" onChange={(e: any) => setPayerPhoneNumber(e.target.value)} value={getPayerPhoneNumber()} />
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    {policy.policyAdditionDetails && (policy.policyAdditionDetails.vehiclePolicyType || policy.policyAdditionDetails.vehiclePolicyType == 0) && policy.policyAdditionDetails.vehiclePolicyType != 6 &&
                        <div className="details-row white-bg flex-grow">
                            <div className="row-sub-title">
                                שעבוד
                            </div>
                            <div className="policy-main-details" style={{ display: 'flex', justifyContent: 'flex-start', gap: '50px' }}>
                                <div className="cell fixed-width">
                                    <div className="title">
                                        משעבד
                                    </div>
                                    <div className="description cell-value">
                                        {policy.policyAdditionDetails && policy.policyAdditionDetails.involvedBank ? policy.policyAdditionDetails.involvedBank :
                                            policy.policyAdditionDetails.involvedName ? policy.policyAdditionDetails.involvedName : ''}
                                    </div>
                                </div>
                                <div className="cell fixed-width">
                                    <div className="title">
                                        רחוב ומספר
                                    </div>
                                    <div className="description cell-value">
                                        {policy.policyAdditionDetails && policy.policyAdditionDetails.involvedBankBranch ? policy.policyAdditionDetails.involvedBankBranch :
                                            policy.policyAdditionDetails.involvedAddress ? policy.policyAdditionDetails.involvedAddress : ''}
                                    </div>
                                </div>
                                <div className="cell fixed-width">
                                    <div className="title">
                                    </div>
                                    <div className="description cell-value">
                                        &nbsp;
                                    </div>
                                </div>
                                <div className="cell fixed-width">
                                    <div className="title">

                                    </div>
                                    <div className="description cell-value">
                                        &nbsp;
                                    </div>
                                </div>
                                <div className="cell fixed-width">
                                    <div className="title">

                                    </div>
                                    <div className="description cell-value">
                                        &nbsp;
                                    </div>
                                </div>
                                <div className="cell fixed-width">
                                    <div className="title">

                                    </div>
                                    <div className="description cell-value">
                                        &nbsp;
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
                <div className="details-row white-bg">
                    <div className="policy-main-details" style={{ display: 'flex', flexWrap: 'wrap', gap: '30px' }}>
                        <div className="cell  fixed-width">
                            <div className="title">
                                הוקם ע"י
                            </div>
                            <div className="description cell-value">
                                {policy && policy.creatorUserId ? getCreatorIfo(policy.creatorUserId) : ''}
                            </div>
                        </div>
                        <div className="cell  fixed-width">
                            <div className="title">
                                עודכן ע"י
                            </div>
                            <div className="description cell-value">
                                {policy && policy.editorUserId ? getUserInfo(policy.editorUserId) : ''}
                            </div>
                        </div>
                        <div className="cell  fixed-width">
                            <div className="title">
                                תאריך עדכון
                            </div>
                            <div className="description cell-value">
                                {policy.policyAdditionDetails && policy.policyAdditionDetails.updatedDate ? new Date(policy.policyAdditionDetails.updatedDate).toLocaleDateString('he-IL') : ''}
                            </div>
                        </div>
                        <div className="cell">
                            <div className="title">
                                הערות
                            </div>
                            <div className="description cell-value">
                                {/* <input style={{ width: 500 }} type="text" value={policy.comments} onChange={(e: any) => onPrimaryDetailsChange("comments", e.target.value)} disabled={!edit} /> */}
                                <PolicyInput type='text'
                                    style={{ width: 500 }}
                                    value={policy.comments}
                                    onChange={(e) => onPrimaryDetailsChange("comments", e.target.value)}
                                    disabled={!edit}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ClientPolicyDetailsCarOrRider;